/* PDP verified comparison chart.
   Renders only when Liquid provides real competitor values. No synthetic
   history or generated market movement. */
(function () {
  function money(value) {
    return '$' + Number(value || 0).toFixed(2);
  }

  function pct(ours, market) {
    if (!market) return 0;
    return Math.round((1 - ours / market) * 100);
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function readCompetitors(root) {
    var competitors = [];
    for (var i = 1; i <= 4; i++) {
      var price = parseFloat(root.getAttribute('data-comp' + i));
      var name = root.getAttribute('data-comp' + i + '-name');
      if (price > 0 && name) {
        competitors.push({ name: name, price: price });
      }
    }
    return competitors;
  }

  function render(root) {
    var list = parseFloat(root.getAttribute('data-list')) || 0;
    var competitors = readCompetitors(root);
    if (list <= 0 || !competitors.length) {
      root.remove();
      return;
    }

    var total = competitors.reduce(function (sum, comp) {
      return sum + comp.price;
    }, 0);
    var market = total / competitors.length;
    var savings = Math.max(0, market - list);
    var savePct = pct(list, market);
    var max = Math.max(market, list, competitors.reduce(function (highest, comp) {
      return Math.max(highest, comp.price);
    }, 0));

    var rows = competitors.map(function (comp) {
      var width = Math.max(8, (comp.price / max) * 100);
      var delta = Math.max(0, comp.price - list);
      return '<div class="acm-chart-bar-row">' +
        '<div class="acm-chart-bar-label">' + esc(comp.name) + '</div>' +
        '<div class="acm-chart-bar-track"><span style="width:' + width.toFixed(2) + '%"></span></div>' +
        '<div class="acm-chart-bar-value acm-mono">' + money(comp.price) + '</div>' +
        '<div class="acm-chart-bar-delta acm-mono">-' + money(delta) + '</div>' +
      '</div>';
    }).join('');

    root.classList.add('acm-chart-wrap');
    root.innerHTML =
      '<div class="acm-chart-kpis acm-mono">' +
        '<div><span>AT COST</span><strong>' + money(list) + '</strong></div>' +
        '<div><span>MARKET AVG</span><strong>' + money(market) + '</strong></div>' +
        '<div class="accent"><span>SAVED</span><strong>-' + savePct + '%</strong><small>' + money(savings) + '</small></div>' +
      '</div>' +
      '<div class="acm-chart-bars">' +
        '<div class="acm-chart-bar-row ours">' +
          '<div class="acm-chart-bar-label">At Cost</div>' +
          '<div class="acm-chart-bar-track"><span style="width:' + Math.max(8, (list / max) * 100).toFixed(2) + '%"></span></div>' +
          '<div class="acm-chart-bar-value acm-mono">' + money(list) + '</div>' +
          '<div class="acm-chart-bar-delta acm-mono">baseline</div>' +
        '</div>' +
        rows +
      '</div>' +
      '<div class="acm-chart-legend">' +
        '<div class="acm-chart-leg strong"><span class="acm-chart-leg-dot"></span><span>Verified competitor prices only</span></div>' +
        '<div class="acm-chart-leg"><span class="acm-chart-leg-dot market"></span><span>No synthetic price history</span></div>' +
      '</div>';
  }

  function init() {
    document.querySelectorAll('[data-acm-chart]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
